import { createSlice } from '@reduxjs/toolkit';

interface DiscordState {
    questStatus?: 'not_enrolled' | 'enrolled' | 'completed';
    questStatusChecked?: boolean;
    windowSize: 'minimized' | 'maximized';
}

const initialState: DiscordState = {
    questStatus: undefined,
    windowSize: 'maximized',
};

export const initialDiscordState = initialState;

const discord = createSlice({
    name: 'discord',
    initialState,
    reducers: {
        setQuestStatus(state, action) {
            state.questStatus = action.payload;
            state.questStatusChecked = true;
        },
        setWindowSize(state, action) {
            state.windowSize = action.payload;
        },
    },
    extraReducers: (builder) => {},
});

export const { setQuestStatus, setWindowSize } = discord.actions;

export const { actions: discordActions, reducer: discordReducer } = discord;

export default discordReducer;
